export default __webpack_public_path__ + "static/icon-26-3-b6d69b9858741a31e6562fd30360252e.png";